angular.module 'zc.core'

# To be replace Facade
.factory 'FacadeV2', ($filter, $httpOnce, $translate, Devise, Project) ->
  class FacadeV2
    login_token = undefined

    @requestTransformer = (data)->
      data.match = FacadeV2.encode {}, data.match
      data.pipeline = FacadeV2.encode {}, data.pipeline
      json: JSON.stringify(data)

    @responseTransformer = (data)->
      res = angular.fromJson data
      if !res || res.error || res.login_expired
        res
      else if _.isArray res.data
        try
          ret = []
          for doc in res.data
            ret.push(FacadeV2.decode {}, doc)
          ret
        catch
          alertify.error $translate.instant('sharedModules.core.services.facade_v2_service.badResponse')
          []
      else
        try
          if res.data
            FacadeV2.decode {}, res.data
          else
            res.data
        catch
          alertify.error $translate.instant('sharedModules.core.services.facade_v2_service.badResponse')
          {}

    @setLoginToken: (login_token) ->
      @login_token = login_token

    @_forPath: (endpoint) ->
      # Don't need to specify the server directory
      # because contains no facade login
      "#{ZC_CONFIG.FACADE_API_URL}:#{ZC_CONFIG.FACADE_API_PORT}/api/v2#{endpoint}"

    @request: (path, opts = {}) ->
      Devise.getCurrentUser().then ->
        reqParams = _.assignIn {}, {
          method: 'GET'
          url: FacadeV2._forPath(path)
          transformResponse: FacadeV2.responseTransformer
          cache: true
          withCredentials: false
          headers:
            'X-LOGIN-TOKEN': Devise?.currentUser?.login_token
        }, opts
        reqParams.params = FacadeV2.requestTransformer reqParams.params if reqParams.params
        $httpOnce(reqParams)

    # FIXME: DRY with v2/facade_controller (facade server)
    # TODO: How to treat objectId
    @decode: (obj, json) ->
      for f,v of json
        if _.isNull(v)
          obj[f] = v
        else if v['.T'] == 'D'
          region = Project.getRegion()
          region ||= 'Asia/Tokyo' # use server region tz for some super slow master-only pages such as /admin/master/reports
          obj[f] = $filter('changeDatetimeFrom')('regionToLocal', v['.V'], 'date', region)
        else if _.isString(v)
          obj[f] = v
        else if _.isNumber(v)
          obj[f] = v
        else if _.isBoolean(v)
          obj[f] = v
        else if _.isArray(v)
          obj[f] = []
          @decode obj[f], v
        else
          obj[f] = {}
          @decode obj[f], v
      obj

    @dateObject: (date) ->
      dateObject = {}

      if Project.getRegion()
        dateObject['.V'] = $filter('changeDatetimeFrom')('localToRegion', date, 'integer')
      else
        # Use browser time when on master only pages where there is no specific project
        # such as /admin/home,
        dateObject['.V'] = date.valueOf()
      dateObject['.T'] = 'D'
      dateObject

    @encode: (json, obj) =>
      for f, v of obj
        if _.isNull(v) || _.isUndefined(v)
          json[f] = null
        else if _.isDate v
          json[f] = @dateObject(v)
        else if _.isString(v)
          json[f] = v
        else if _.isNumber(v)
          json[f] = v
        else if _.isBoolean(v)
          json[f] = v
        else if _.isArray(v)
          json[f] = []
          @encode json[f], v
        else
          json[f] = {}
          @encode json[f], v
      json

  FacadeV2



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/core/services/facade_v2_service.js.coffee